import { defineComponent as q, useSlots as z, computed as t, watchEffect as G, createBlock as v, openBlock as s, unref as y, withCtx as H, createElementVNode as g, normalizeClass as r, createElementBlock as p, createCommentVNode as n, renderSlot as k, mergeProps as L, resolveDynamicComponent as U, toRaw as J } from "vue";
import K from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevIllustration as M } from "@ds/components/Illustration";
import { isString as c } from "../../utils/isString.js";
import { isValidNumber as C } from "../../utils/isValidNumber.js";
import { tw as a } from "../../utils/tailwind.js";
import { CHANGE_EVENT as Q } from "./Checkbox.constant.js";
const X = ["for"], se = /* @__PURE__ */ q({
  name: "RevCheckbox",
  __name: "Checkbox",
  props: {
    checked: { type: [Boolean, Array], default: void 0 },
    modelValue: { type: [Boolean, Array], default: !1 },
    disabled: { type: Boolean, default: !1 },
    displayDescriptionOnlyWhenChecked: { type: Boolean, default: !1 },
    id: {},
    image: { type: [String, Object, Function], default: void 0 },
    imageProps: { default: void 0 },
    value: { default: "on" },
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(w, { emit: N }) {
    const e = w, h = z(), m = N, A = t(() => h.label ? e.variant !== "imageOnly" : !1), V = t(() => h.description ? e.variant === "full" : !1), i = t(() => e.value && Array.isArray(e.checked) ? e.checked.includes(e.value) : e.value && Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.checked !== void 0 ? e.checked : e.modelValue !== void 0 ? e.modelValue : !1);
    function x(l) {
      const d = l;
      m(Q, d);
      const $ = ["checked", "modelValue"];
      for (const j of $) {
        const u = e[j];
        if (typeof u == "boolean") {
          m("update:modelValue", d.target.checked);
          return;
        }
        if (Array.isArray(u)) {
          const F = d.target.checked ? [...u, e.value] : u.filter((W) => W !== e.value), T = Array.from(new Set(F));
          m("update:modelValue", T);
          return;
        }
      }
    }
    const o = t(() => {
      const l = e.imageProps || {};
      return {
        ...l,
        height: C(l.height) ? l.height : 24,
        width: C(l.width) ? l.width : 24,
        src: c(e.image) ? e.image : void 0,
        alt: c(l.alt) ? l.alt : void 0
      };
    }), O = t(() => e.variant !== "default" && c(o.value.alt));
    G(() => {
      if (e.variant === "imageOnly" && !o.value.alt)
        throw new Error(
          "Checkbox: image must have an alt text when using the ImageOnly variant."
        );
    });
    function b(l) {
      return c(l);
    }
    const B = t(() => typeof e.image == "object"), f = a`ease-in motion-safe:transition-colors motion-safe:duration-200`, D = t(() => [
      a`text-static-default-low body-2 ml-32 pt-8`,
      e.displayDescriptionOnlyWhenChecked && !i.value && a`hidden`,
      e.disabled && a`text-static-default-low-disabled`,
      f
    ]), E = t(() => [
      f,
      a`body-1 block`,
      e.variant !== "default" && a`rounded-sm box-border border p-16 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`min-h-56`,
      !e.disabled && i.value && a`border-action-default-low-pressed`,
      !e.disabled && !i.value && a`border-action-default-low`,
      !e.disabled && e.variant !== "default" && a`bg-static-default-low hover:bg-static-default-low-hover`,
      !e.disabled && a`text-action-default-hi cursor-pointer`,
      e.disabled && e.variant !== "default" && a`bg-static-default-low-disabled border-action-default-low-disabled`,
      e.disabled && a`text-action-default-hi-disabled cursor-not-allowed`
    ]), P = a`ml-32 flex`, S = a`flex-1 ${f}`, _ = t(() => [
      a`flex max-h-24 items-center`,
      e.variant === "full" && a`ml-16`,
      e.disabled && a`opacity-50`
    ]), I = t(() => ({
      full: a`left-16 top-20`,
      imageOnly: a`left-16 top-16 peer-focus-visible:outline-default-hi`,
      default: a`top-2 peer-focus-visible:outline-default-hi`
    })[e.variant]), R = t(() => e.variant === "full" && !i.value);
    return (l, d) => (s(), v(y(K), {
      id: l.id,
      disabled: l.disabled,
      "is-transparent": R.value,
      label: "",
      "model-value": i.value,
      "tick-class-names": I.value,
      value: l.value,
      onChange: x
    }, {
      default: H(() => [
        g("label", {
          class: r(E.value),
          for: l.id
        }, [
          g("div", {
            class: r(P)
          }, [
            A.value ? (s(), p("div", {
              key: 0,
              class: r(S)
            }, [
              k(l.$slots, "label")
            ])) : n("", !0),
            O.value ? (s(), p("div", {
              key: 1,
              class: r(_.value)
            }, [
              b(o.value.src) && b(o.value.alt) ? (s(), v(y(M), L({ key: 0 }, o.value, {
                alt: o.value.alt,
                src: o.value.src
              }), null, 16, ["alt", "src"])) : n("", !0),
              B.value ? (s(), v(U(J(l.image)), {
                key: 1,
                "aria-label": o.value.alt,
                role: "img"
              }, null, 8, ["aria-label"])) : n("", !0)
            ], 2)) : n("", !0)
          ]),
          V.value ? (s(), p("div", {
            key: 0,
            class: r(D.value)
          }, [
            k(l.$slots, "description")
          ], 2)) : n("", !0)
        ], 10, X)
      ]),
      _: 3
    }, 8, ["id", "disabled", "is-transparent", "model-value", "tick-class-names", "value"]));
  }
});
export {
  se as default
};
